import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { createGuid } from '@office-start/guid-generator';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { OfficeWorkload } from '@office-start/officehome-types';
import { httpPost } from '@office-start/xhr-service';
import { createUserActionInputType } from '../util/createUserActionInputType';
import { createRequestConfig } from './createRequestConfig';
export function postFeedbackInstrumentationInternal(options, props, isRemoveFromFeed) {
    var _a, _b;
    if (isRemoveFromFeed === void 0) { isRemoveFromFeed = false; }
    return __awaiter(this, void 0, void 0, function () {
        var objectId, tenantId, substrateApi, inMockMode, officeApiRoot, aadClientId, correlationId, officeComponentContext, featureGates, isUserActionsAPIEnabled, application, requestId, requestConfig, apiRoot, mockParams, url, httpPostBody;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    objectId = options.objectId, tenantId = options.tenantId, substrateApi = options.substrateApi, inMockMode = options.inMockMode, officeApiRoot = options.officeApiRoot, aadClientId = options.aadClientId, correlationId = options.correlationId;
                    return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    officeComponentContext = _c.sent();
                    return [4 /*yield*/, fetchFeatureGates()];
                case 2:
                    featureGates = _c.sent();
                    isUserActionsAPIEnabled = ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.userActionsAPIGates) === null || _b === void 0 ? void 0 : _b.userActionsAPIEnabled) ||
                        false;
                    application = officeComponentContext.workload === OfficeWorkload.Hwa
                        ? 'OfficeComApp'
                        : 'OfficeComHome';
                    requestId = createGuid();
                    requestConfig = createRequestConfig(requestId, objectId, tenantId, aadClientId, application, true, isUserActionsAPIEnabled ? correlationId : undefined);
                    apiRoot = substrateApi;
                    if (inMockMode) {
                        apiRoot = officeApiRoot;
                        mockParams = {
                            mockParam: 'mockrecommendeddelete',
                        };
                    }
                    url = isUserActionsAPIEnabled
                        ? "".concat(apiRoot, "/PeoplePredictionsB2/graphql?operationName=sendUserAction")
                        : "".concat(apiRoot, "/peoplepredictionsb2/Feedback");
                    httpPostBody = isUserActionsAPIEnabled
                        ? getUserActionsBody(props.feedbackIds, props.actions, props.timeStamp)
                        : getFeedbackInstrumentationBody(props.feedbackIds, props.actions, props.timeStamp, props.target);
                    if (inMockMode) {
                        // TODO: need to set up mock api?
                        return [2 /*return*/, Promise.resolve()];
                    }
                    return [2 /*return*/, httpPost(isRemoveFromFeed
                            ? KnownInstrumentationEvents.OfficeFeedDelete
                            : KnownInstrumentationEvents.OfficeFeedInstrumentation, isRemoveFromFeed
                            ? "OfficeFeedDelete" /* KnownRequestInstrumentationEvents.OfficeFeedDelete */
                            : "OfficeFeedInstrumentation" /* KnownRequestInstrumentationEvents.OfficeFeedInstrumentation */, url, httpPostBody, requestConfig, options.jwtAuthEnabled, options.getAccessToken, options.officeApiRoot, options.correlationId, 'Substrate', mockParams).catch(function (error) {
                            console.log('Failed to log Feedback instrumentation');
                            throw error;
                        })];
            }
        });
    });
}
function getFeedbackInstrumentationBody(feedbackIds, actions, timeStamp, target) {
    var actionsArray = [];
    for (var i = 0; i < feedbackIds.length; i++) {
        actionsArray.push({
            FeedbackId: feedbackIds[i],
            Action: actions[i],
            Timestamp: timeStamp,
            Target: target,
        });
    }
    var instrumentationBody = {
        Actions: actionsArray,
    };
    return instrumentationBody;
}
function getUserActionsBody(feedbackIds, actions, timeStamp) {
    var operationName = 'sendUserAction';
    // Creating the graphql query as a string instead of using gql.
    var query = 'mutation sendUserAction($currentDateTime:DateTimeOffset!$userActions:[UserActionLogInputType!]!){userActions{log(currentDateTime:$currentDateTime userActions:$userActions){errors{errorType __typename}__typename}__typename}}';
    var userActionsArray = [];
    for (var i = 0; i < feedbackIds.length; i++) {
        userActionsArray.push({
            feedbackId: feedbackIds[i],
            action: createUserActionInputType(actions[i]),
            timestamp: timeStamp,
        });
    }
    var variables = {
        userActions: userActionsArray,
        currentDateTime: timeStamp,
    };
    var userActionsBody = {
        operationName: operationName,
        query: query,
        variables: variables,
    };
    return userActionsBody;
}
//# sourceMappingURL=postFeedbackInstrumentationInternal.js.map